<template>
    <div class="demo-spin-article report__table">
        <div class="ls_action_header">
            <Row :gutter="24" type="flex" class="ls_action_header mb-30">
                <Col :xs="24" :sm="12" :md="12" :lg="0"
                ><Select
                        class="mb-10 select-box"
                        v-model="filter.cash"
                        placeholder="Касса"
                >
                    <Option
                            v-for="item in filterOptions.cash"
                            :value="item.id"
                            :key="item.id"
                    >{{ item.name }}
                    </Option>
                </Select></Col
                >
                <Col :xs="24" :sm="12" :md="12" :lg="0"
                ><DatePicker
                        v-model="filterOpenDate"
                        @on-change="changeFilterOpenDate"
                        @on-clear="clearFilterOpenDate"
                        format="dd.MM.yyyy"
                        type="daterange"
                        :start-date="currentDate"
                        placeholder="Дата открытия"
                        :clearable="false"
                ></DatePicker
                ></Col>
            </Row>
        </div>


        <!-- DATA MOBILE TABLE -->
        <div class="mobile-table">

            <div v-for="item in data" class="card-container">
                <div>
                    <h2>№{{item.number}}</h2>
                    <p>Время: {{formatDateTime(item.order_date)}}</p>
                    <p>Скидка: {{formatNumber(item.total_discount_sum)}} {{currency}}</p>
                    <p>Сумма: {{formatNumber(item.total_sum)}} {{currency}}</p>
                </div>

                <div>
                    <Button type="primary" class="price" @click="fetchReportText(item.id)"
                            style="border: none; color: #5087DE; text-decoration: underline; background: none; box-shadow: none; font-weight: bold"
                    >Просмотр
                    </Button>
                </div>

            </div>
        </div>

        <!-- DATA TABLE + PAGINATION -->
        <Table
                :loading="loading"
                :columns="columns"
                :data="data"
                class="desktop_table"
        >

        </Table>

        <Modal v-model="modalReport"
               title="Чек"
               width="300"
               cancelText="Закрыть"
               okText="Печать"
               :styles="{top: '20px'}"
        >
            <div class="report_body" id="ticketModalBody">
                <h2 class="report_header" style="text-align: center;">ДУБЛИКАТ</h2>
                <div class="report_text">{{ reportText }}</div>
                <div style="max-width: 233px; margin: 0 auto">
                    <qrcode-vue :value="qrValue" level="H"></qrcode-vue>
                </div>
            </div>
            <div slot="footer">
                <Button type="success" size="large" @click="modalPrint">Печать</Button>
                <Button type="error" size="large" @click="modalClose">Закрыть</Button>
            </div>
        </Modal>


<!--        <Modal v-model="modalReport" title="Отчет" width="300" cancelText="Закрыть" okText="Печать">-->
<!--            <div class="report_body">{{ reportText }}</div>-->
<!--        </Modal>-->
    </div>
</template>
<script>
    import {
        formatNumber,
        formatDate,
        formatDateTime
    } from "../../base/base_func.js";
    import { base_url } from "../../http.js";
    import { BaseTableData } from "../../base/base_table.js";

    const REPORT = {
        Z_REPORT: "z_report",
        SECTION_REPORT: "section_report",
        CASHIER_REPORT: "cashier_report",
        CONTROL_TAPE: "control_tape"
    };

    let _app = BaseTableData();
    // _app.components = {
    //     ticketHistoryExpand
    // };

    _app.data = function() {
        return {
            // Base settings
            baseViewUrl: base_url + "/proxy/shifts/",
            // item_type: "reports",
            loading: true,

            // Table settings
            columns: [
                {
                    title: "№",
                    // width: 340,
                    key: "number"
                    // sortable: true,
                },
                {
                    title: "Время",
                    // width: 80,
                    align: "center",
                    // key: "order_date_display",
                    // sortable: true,
                    render: (h, params) => {
                        return h("span", {}, this.formatDateTime(params.row.order_date));
                    }
                },
                {
                    title: "Скидка",
                    // width: 80,
                    key: "amountDiscount",
                    align: "right",
                    sortable: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {},
                            this.formatNumber(params.row.total_discount_sum) + " " + this.currency
                        );
                    }
                },
                {
                    title: "Сумма",
                    // width: 80,
                    key: "amountTotal",
                    align: "right",
                    sortable: true,
                    render: (h, params) => {
                        return h(
                            "div",
                            {},
                            this.formatNumber(params.row.total_sum) + " " + this.currency
                        );
                    }
                },
                {
                    title: "Просмотр",
                    // width: 80,
                    // key: "total_sum",
                    align: "center",
                    // sortable: true,
                    render: (h, params) => {
                        return h(
                            "Button",
                            {
                                props: {type: "primary"},
                                nativeOn: {
                                    click: this.showReportAction(params.row.id)
                                },
                                style: {
                                    border: 'none',
                                    color: '#5087DE',
                                    textDecoration: 'underline',
                                    background: 'none',
                                    boxShadow: 'none',
                                    fontWeight: 'bold'
                                }
                            },

                            "ПРОСМОТР"
                        );
                    }
                }
            ],
            data: [],
            lastDraw: 0,

            filter: {
                cash: '',
                open_date__gt: "",
                open_date__lt: "",
            },
            filterOptions: {
                cash: []
            },

            filterOpenDate: ["", ""],
            selected: [],

            modalReport: false,
            reportText: "",

            // item: {
            //   show: false,
            //   id: null,
            //   action: null
            // }
        };
    };

    _app.computed.fetchParams = function() {
        let params = {
            // draw: this.lastDraw,
            // offset: this.start,
            // limit: this.pageSize,
            // search: this.searchString,
            // ordering: this.sorting
        };

        for (let key in this.filter) {
            if (this.filter[key]) {
                params[key] = this.filter[key];
            }
        }

        return params;
    };

    _app.computed.currentDate = function(){
        let date = new Date();
        date.setMonth(date.getMonth() - 1);
        return date;
    };

    _app.methods.showReportAction = function (ticket_id) {
        return () => {
            this.fetchReportText(ticket_id);
        };
    };

    _app.methods.changeFilterOpenDate = function(date_arr, date_obj) {
        if (date_arr[0] && date_arr[1]) {
            this.filter.open_date__gt = this.filterOpenDate[0];
            this.filter.open_date__lt = this.filterOpenDate[1];
        }
    };
    // Очистка полей поиска даты документа (Order date), после чего срабатывает watcher и обновляются данные в таблице
    _app.methods.clearFilterOpenDate = function(date_arr, date_obj) {
        this.filter.open_date__gt = "";
        this.filter.open_date__lt = "";
    };

    _app.methods.formatNumber = function(number) {
        return formatNumber(number);
    };

    _app.methods.fetchCash = function() {
        const url = base_url + "/cashes/?use_nonfiscal=True";
        this.$http
            .get(url)
            .then(result => {
                this.filterOptions.cash = result.data.results;
                this.filter.cash = result.data.results[0].id;
               // this.fetchItems();
            })
            // .catch(error => {
            //     this.$Message.error("Произошла ошибка");
            // })
          .finally(() => {
            this.loading = false;
          });
    };


    // Загружаем данные для таблицы
    _app.methods.fetchItems = function() {
        this.loading = true;
        this.lastDraw++;
        let cashbox_id = this.filter.cash;
        let url = `${base_url}/operations/?cash=${cashbox_id}`;
        this.$http
            .get(url, {
                params: {
                    order_date__gt: this.filter.open_date__gt,
                    order_date__lt: this.filter.open_date__lt,
                    is_fiscal: false
                }

            })
            .then(result => {
                // let num = 0;
                // result.data.results.forEach(item => {
                //     num ++;
                //     item.number = num;
                // });
                this.data = result.data.results;

            })
            .finally(() => {
                this.loading = false;
            });
    };

    _app.methods.b64DecodeUnicode = function(str) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(
            atob(str)
                .split("")
                .map(function(c) {
                    return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join("")
        );
    };

    _app.methods.fetchReportText = function (ticket_id) {
        const url = `${base_url}/operations/${ticket_id}/`;
        this.reportText = "";
        this.qrValue = "";
        this.$http
            .get(url)
            .then(result => {

                this.reportText = this.b64DecodeUnicode(result.data.receipt);
                this.qrValue = this.b64DecodeUnicode(result.data.ofd_qr);
                // try {
                //   this.qrValue = this.b64DecodeUnicode(result.data.ofd_qr);
                // } catch (e) {
                //   this.qrValue = '';
                // }

                this.modalReport = true;
                // console.log(this.reportText);
                // this.filterOptions.cash = result.data.results;
            })
            .catch(error => {
                this.$Message.error("Произошла ошибка");
            });
    };

    _app.methods.fetchReportPdf = function(shift_id, report_type) {
        // window.onbeforeunload = function () {};
        //
        // location.href = base_url + "/product_order/pdf/";
        //
        // window.onbeforeunload = function () {
        //   return "Вы уверены, что хотите закрыть приложение?";
        // };

        const url = `${this.baseViewUrl}${shift_id}/${report_type}/`;
        this.$http({
            url: url,
            method: "GET",
            responseType: "blob" // important
        })
            .then(response => {
                const blob = new Blob([response.data], { type: "application/pdf" });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.style.display = "none";
                a.href = url;
                // the filename you want
                // console.log(response);
                // let headerLine = response.headers['content-disposition'];
                // let startFileNameIndex = headerLine.indexOf('"') + 1;
                // let endFileNameIndex = headerLine.lastIndexOf('"');
                // let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);

                // a.download = `${this.doc_templates_obj[type]}.pdf`;
                a.download = `ControlTapeReport.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            })
            .catch(error => {
                this.$Message.error("Произошла ошибка. Попробуйте позже.");
                console.log(error);
            });
    };

    _app.methods.setInitialDates = function () {
        let start_date = new Date();
        let end_date = new Date();

        start_date.setDate(start_date.getDate() - 7).toString();

        this.filterOpenDate[0] = start_date;
        this.filterOpenDate[1] = end_date;

        this.filter.open_date__gt = start_date;
        this.filter.open_date__lt = end_date;
    };



    _app.methods.modalPrint = function () {
        printJS({
            printable: 'ticketModalBody',
            type: 'html',
            style: `.report_body {
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  font-family: Consolas, serif;
  font-size: 8px;
  font-weight: 400;
  line-height: 15px;
  overflow-wrap: break-word;
  pointer-events: auto;
  text-align: left;
  white-space: pre-wrap;
}
.report_text {
  display: flex;
  justify-content: center;
  overflow: hidden;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  font-family: Consolas;
  line-height: 15px;
  font-size: 15px;
  font-weight: 400;
  font-style: normal;
  color: #000;
  background-color: transparent;
}`

        });
    };
    _app.methods.modalClose = function () {
        this.modalReport = false;
    };




    _app.created = function() {
        this.setInitialDates();
        this.fetchCash();
    };

    _app.mounted = function() {
      // this.fetchItems();
      this.initialRoute(this.$route);
      this.setFilterWatchers();
    };

    export default _app;
</script>

<style scoped>
    .report_body {
        /*width: 420px;*/
        box-sizing: border-box;
        color: rgb(0, 0, 0);
        font-family: Consolas, serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 15px;
        overflow-wrap: break-word;
        pointer-events: auto;
        text-align: left;
        white-space: pre-wrap;
    }

    .select-box {
        width: 220px;
    }

    @media screen and (max-width: 991px) {
        .select-box {
            width: 100%;
        }
    }


</style>


<style>

    .datepicker_input, .ivu-date-picker input {
        max-width: 260px;
        width: 260px;
    }


    @media screen and (max-width: 991px) {
        .datepicker_input, .ivu-date-picker, .ivu-date-picker input {
            max-width: 100%;
            width: 100%;
        }
    }

    @media screen and (max-width: 767px) {
        .ivu-table-tip table {
            min-height: 50vh;
        }
    }


    @media screen and (min-width: 992px) {
        .ivu-col-span-lg-0 {
            display: block;
            width: auto;
        }
    }

</style>



// WEBPACK FOOTER //
// src/apps/report/productOperations.vue